import { ReactTFC } from "../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import { CSS_COLORS, CSS_SPACER_SIZES } from "../../styles/styles-css-variables";
import React from "react";
import { ContactDataType } from "@swo/shared";
import { fontColor, FONTS, fontSize } from "../../styles/fonts";
import { SwarovskiButton } from "../_shared-components/ui-elements/SwarovskiButton";
import { showChatbotMessengerEffect } from "../../domain/intercom/show-chatbot-messenger-effect";
import { IconWithTextElement } from "./IconWithTextElement";
import { IconWithTextElementWrapper } from "./IconWithTextElementWrapper";
import type { TranslatedValue } from "@swo/storefront";

export const CustomerServiceContactData: ReactTFC<{
  contactData: ContactDataType;
  headline: TranslatedValue | undefined;
  chatbotEnabled: boolean;
  noSpacing?: boolean;
}> = props => {
  return (
    <IconWithTextElementWrapper noSpacing={props.noSpacing}>
      <CustomerServiceContactDataElement
        contactData={props.contactData}
        headline={props.headline}
        chatbotEnabled={props.chatbotEnabled}
      />
    </IconWithTextElementWrapper>
  );
};

const CustomerServiceContactDataElement: ReactTFC<{
  contactData: ContactDataType;
  headline: TranslatedValue | undefined;
  chatbotEnabled: boolean;
}> = ({ contactData, headline, chatbotEnabled }) => {
  return (
    <IconWithTextElement headline={headline} media={contactData.media} subheadline={contactData.headline}>
      <span
        css={css`
          ${FONTS.SwarovskiFutura300};
          ${fontColor.black};

          font-size: 16px;
          letter-spacing: 0.8px;
          text-align: center;
          line-height: 24px;

          margin-bottom: 16px;
        `}
      >
        {contactData.availabilityHours}
      </span>

      <a
        css={[
          FONTS.SwarovskiFutura500,
          fontSize.x2,
          css`
            color: ${CSS_COLORS.Green};

            margin-bottom: 12px;
            text-decoration: none;
          `,
        ]}
        href={`tel:${contactData.phone}`}
      >
        {contactData.phone}
      </a>
      <a
        css={[
          FONTS.SwarovskiFutura500,
          fontSize.x2,
          css`
            color: ${CSS_COLORS.Green};
            text-decoration: none;
            word-break: break-word;
          `,
        ]}
        href={`mailto:${contactData.email}`}
      >
        {contactData.email}
      </a>

      {chatbotEnabled && contactData.showChatbotMessenger ? (
        <SwarovskiButton
          css={css`
            margin-top: 10px;
          `}
          as="button"
          variant="plain-underline"
          onClick={showChatbotMessengerEffect}
        >
          {contactData.showChatbotMessenger}
        </SwarovskiButton>
      ) : null}
    </IconWithTextElement>
  );
};
